import { ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { ProductsMange } from "./productsManange";
import { IPagination } from "./pagination/Ipagination";

@Component({
  selector: "app-shop",
  templateUrl: "./shop.component.html",
  styleUrls: ["./shop.component.scss"]
})
export class PeoductsSearch extends ProductsMange implements OnInit {
  p: number = 1;
  pagination: IPagination;

  constructor(
    public _facadeService: FacadeService,
    private _route: ActivatedRoute
  ) {
    super(_facadeService);
  }

  ngOnInit() {
    this.getProducts();
    this.getAllCatogeries();
  }

  getProducts() {
    this.products = [];
    this._route.paramMap.subscribe(params => {
      this._facadeService.Product.search({
        page: this.p,
        keywords: params.get("search_word")
      }).subscribe(res => {
        this.setProductRespone(res);
        this.pagination = {
          currentPage: res.data.current_page,
          lastPage: res.data.last_page
        };
      });
    });
  }

  onLoad(index: number) {
    this.loaded(index);
  }

  pageChanged(page) {
    // Change the current page
    this.pagination.currentPage = page;
    this.p = page;

    // Scroll to top
    window.scroll(0, 0);

    // Get the new page data
    this.getProducts();
  }
}
